<script setup lang="ts">
import type { IProps } from './UiTag.types'
defineProps<IProps>()
</script>

<template>
  <p class="tag">
    {{ label }}
  </p>
</template>

<style lang="scss" scoped>
  .tag {
    @include body-4;
    width: fit-content;
    padding: .4rem 1.2rem;
    color: $text-200;
    background-color: $gray-100;
    border: 1px solid $base-50;
    border-radius: .8rem;
  }
</style>
